/** Prefixes a distribution list's slug with "@" for display, without doubling
 * the prefix if the value already carries one. */
export function formatDistributionListHandle(slug) {
  if (!slug) return "";
  return slug.startsWith("@") ? slug : `@${slug}`;
}
